(function () {
	'use strict';

	angular
		.module('app')
		.directive('compareValueValidator', compareValueValidator);

	compareValueValidator.$inject = ['$window'];

	function compareValueValidator($window) {
		// Usage:
		//     <compareValue></compareValue>
		// Creates:
		// 
		var directive = {
			restrict: 'A',
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, $ctrl) {
			$ctrl.$parsers.unshift(function (value) {
				let isValid = false;

				if (value) {
					var compareValue = $("#" + $attrs.compareValueValidator).val();
					isValid = value === compareValue;
					$ctrl.$setValidity('invalidCompare', isValid);

					return isValid ? value : "";
				} else {
					return isValid;
				}
			});
		}
	}
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/validators/_compareValueValidator.js
// module id = 19
// module chunks = 0